import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  deleteDashboardLayout,
  getDashboardLayout,
  putDashboardLayout,
  type DashboardLayoutV1,
} from '../lib/dashboardLayoutApi';

// Configurable dashboard — layout persistence hooks. `null` data means "no
// saved layout" (the page falls back to the default layout for the caller).

const LAYOUT_KEY = ['dashboard', 'layout'] as const;
const FIVE_MINUTES = 5 * 60 * 1000;

export function useDashboardLayout() {
  return useQuery({
    queryKey: LAYOUT_KEY,
    queryFn: () => getDashboardLayout(),
    staleTime: FIVE_MINUTES,
  });
}

export function useSaveDashboardLayout() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (layout: DashboardLayoutV1) => putDashboardLayout(layout),
    onSuccess: (saved) => {
      queryClient.setQueryData(LAYOUT_KEY, saved);
    },
  });
}

export function useResetDashboardLayout() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => deleteDashboardLayout(),
    onSuccess: () => {
      queryClient.setQueryData(LAYOUT_KEY, null);
    },
  });
}
